<template>
    <div class="overall-bg">
        <div class="form-white-bg">
            <b-container>
                <div class="d-flex ms-4">

                    <div class="field me-3">
                        <Datepicker v-model="itemcatfilter" :label="$t('item.fromdate')" :name="$t('item.fromdate')"
                            :id="$t('item.fromdate')" />

                    </div>
                    <div class="field me-2">
                        <Datepicker v-model="itemcatfilter" :label="$t('item.todate')" :name="$t('item.todate')"
                            :id="$t('item.todate')" />
                    </div>
                </div>
                <div class="raisepoflex">
                    <div class="raisepo ms-3">
                        <p>20 Items Selected</p>
                        <p class="light-txt">Unselect all</p>
                        <span class="blue-txt" @click="raisePO()">Raise PO</span>

                    </div>
                    <div class="d-flex align-items-center">
                        <div class="field me-2">
                            <CustomDropdown name="itemcatfilter" v-model="itemcatfilter" :items="itemcatfilteroptions"
                                placeholder="Select Category" @change="$.emit('FilterPOItems', itemcatfilter)" />
                        </div>
                        <!-- <AddButton btnname="Download Excel" @click="$.emit('AddSelectItems', selectedItem)"></AddButton> -->
                        <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                            :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                    </div>

                </div>
                <NormalTable v-model:value="items" :paginator="true" class="p-datatable-gridlines" :rows="10"
                    dataKey="Id" :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                    :globalFilterFields="globalFilterFields" :filters=filters :selectionMode="true"
                    :exceldownload="true" v-model:selection="selectedItem"
                    @update:selection="$.emit('selectedItem', selectedItem)" :addnewbtn="true">
                    <!-- <template v-slot:exceldownload>
                        <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                            :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                    </template> -->
                    <!-- <template v-slot:Add>
                    <span>
                        <AddButton btnname="Download Excel" @click="$.emit('AddSelectItems', selectedItem)"></AddButton>
                    </span>
                </template>
<template v-slot:dropdownfilter>
                    <span class="field me-2">
                        <CustomDropdown name="itemcatfilter" v-model="itemcatfilter" :items="itemcatfilteroptions"
                            placeholder="Select Category" @change="$.emit('FilterPOItems', itemcatfilter)" />
                    </span>
                </template> -->
                    <template v-slot:Qty="{ data }">
                        <div class="label-d-none tablefield mb-0">
                            <TextField name="" id="" label="" v-model="data.ItemQuantity" :rules="{ numeric: true }"
                                :disabled="data.IsConsigneeItem == 1 ? true : false"
                                @update:modelValue="UpdateQty(data)" @keyup="QtyChk(data)" />
                        </div>
                    </template>
                    <template v-slot:BatchNo="{ data }">
                        <div class="label-d-none tablefield mb-0">
                            <TextField v-if="data.BatchRequired" type="text" placeholder="" clearable name="" id=""
                                label="" v-model="data.BatchNo" :rules="{ required: false, numeric: true }"
                                :requiredIcon="false" :disabled="false" />
                        </div>
                    </template>
                    <template v-slot:ExpiryDate="{ data }">

                        <div class="label-d-none tablefield mb-0" v-if="data.ExpiryDtRequired == true">
                            <div v-if="requestForm.DocType == '7'">
                                <Datepicker dateformat="dd-mm-yy" v-model="data.ExpiryDate1" :disabled="false" />
                            </div>
                            <p v-else>

                            </p>
                        </div>
                    </template>
                    <template v-slot:FreeQty="{ data }">
                        <div class="label-d-none tablefield mb-0">
                            <TextField type="text" placeholder="" clearable name=""
                                id="$t('userManagement.branch.branchCode')" @keyup="" label="" v-model="data.FreeQty"
                                :rules="{ required: false, numeric: true }" :requiredIcon="false"
                                :disabled="data.IsConsigneeItem == 1 ? true : false" />
                        </div>
                    </template>
                </NormalTable>
            </b-container>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, watch } from "vue";
import AddButton from "../../../../../components/GeneralButtons/AddButton.vue";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue"
import { FilterMatchMode } from "primevue/api";
import { object } from "yup";
import NormalTable from "../../../../../components/FormComponents/NormalTable.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import { useToast } from "primevue/usetoast";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import ExportOption from "../../../../../components/FormComponents/Export.vue";
import commonService from "../../../Service/WithoutStockAffectService";

export default defineComponent({

    props: {
        items: {
            type: Array,
            default: []
        },
        selectedList: {
            type: Array,
            default: []
        },
        itemcatfilteroptions: {
            type: Array,
            default: []
        },
        requestForm: {
            type: Object,
            default: {}
        },
        receivedList: {
            type: Array,
            default: []
        }
    },
    components: {
        ExportOption,
        Tableview,
        AddButton,
        CustomDropdown,
        NormalTable,
        TextField,
        Datepicker
    },
    setup(props, { emit }) {
        const items: any = ref([]);
        const itemcatfilter = ref();
        // const itemcatfilteroptions: any = ref([]);
        const selectedItem: any = ref([]);
        const toast = useToast();
        const router = useRouter();
        const routes = useRoute();

        watch(
            () => props.items,
            (newVal) => {
                items.value = newVal

            }
        );
        watch(
            () => props.selectedList,
            (newVal) => {
                selectedItem.value = newVal
            }
        );
        const headers = [
            {
                header: "Code",
                field: "ItemProductId",
            },
            {
                header: "Name",
                field: "Itemname1",
                // slot: "Itemname1",
                // sortable: false,
                // fieldDisplay: "false",
            },


            {
                header: "Supplier Name",
                field: "PurchasePercentage",
                // bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Last PO Date",
                field: "PurchasePercentage",
                // bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "UOM",
                field: "Purchasetaxamount",
                // bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Avl Qty",
                field: "Purchasetaxamount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Min Level",
                field: "SGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Max Level",
                field: "SGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Consumption",
                field: "CGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Reorder Level",
                field: "CGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },

            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                class: "last-column-position",
                fieldDisplay: "false",
            },
        ];
        const globalFilterFields = ref(headers.map((col) => col.field));


        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            ItemProductId: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Itemname1: { value: null, matchMode: FilterMatchMode.IN, options: items },
            DispensingName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Qty: { value: null, matchMode: FilterMatchMode.IN, options: items },
            HSNManulCode: { value: null, matchMode: FilterMatchMode.IN, options: items },
            OrderingName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            BatchNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
            RequestedQty: { value: null, matchMode: FilterMatchMode.IN, options: items },
            FreeQty: { value: null, matchMode: FilterMatchMode.IN, options: items },
            UnitRate: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Rate: { value: null, matchMode: FilterMatchMode.IN, options: items },
            servicecharges: { value: null, matchMode: FilterMatchMode.IN, options: items },
            othercharges: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Purchasetaxamount: { value: null, matchMode: FilterMatchMode.IN, options: items },
            PurchasePercentage: { value: null, matchMode: FilterMatchMode.IN, options: items },
            SGSTTax: { value: null, matchMode: FilterMatchMode.IN, options: items },
            CGSTTax: { value: null, matchMode: FilterMatchMode.IN, options: items },
            CGSTTaxAmount: { value: null, matchMode: FilterMatchMode.IN, options: items },
            IGSTTax: { value: null, matchMode: FilterMatchMode.IN, options: items },
            IGSTTaxAmount: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Discount: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Discountamount: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Totalvalue: { value: null, matchMode: FilterMatchMode.IN, options: items },
            MRP: { value: null, matchMode: FilterMatchMode.IN, options: items },
            BrandName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            BinLocation: { value: null, matchMode: FilterMatchMode.IN, options: items },
        };
        //Qty update for Category Filter // ItemQuantity in v-model so not emitting
        function UpdateQty(data) {
            debugger;
            data.ItemQty1 = data.ItemQuantity


        }
        //Condition chk for PoQty
        function QtyChk(data) {
            if (Number(data.ItemQuantity) > Number(data.ChkPOQty)) {
                toast.add({
                    severity: "warn",
                    summary: "Quantity Exceeds Requested Quantity",
                    detail: "",
                    life: 3000,
                });
                data.ItemQuantity = data.ChkPOQty;

            }
            (props.receivedList.length == 0) ? emit('amountCalc', data, items) : ''
        }
        function raisePO() {
            debugger;
            router.push({
                path: "/reOrderLevelBasedPO",

            });
        }


        let FilterLoading = ref(true);
        const filtervisible = ref(false);
        let filterItemsArray: any = ref([]);
        const rowsCount = ref(0);
        let loading = ref(false);
        let dataId = routes.query.Id ?? 0;
        let columnnametype = routes.query.Type ?? "";
        let status = routes.query.status ?? 0;
        let filterItems = ref({
            Date: "",
            SupplierName: "",
            SupplierId: "",
            Code: "",
            PoCode: "",
            StatusName: "",
            StatusIds: "",
        });
        let SearchValue = ref({
            inputValue: "",
            fromDate: "",
            toDate: "",
        });
        let buttonFilter = ref({
            Id: 0,
            Name: "",
        });
        const state = reactive({
            pagedItems: [], // contains a subset of rows for the current page
            currentPage: 1, // current page number
            pageSize: 10, // number of rows per page
            totalRows: 0, // total number of rows in the database
        });
        let ExportList = ref([]);
        let PageName = ref("");
        let ExportOption = ref("");
        let SessionUserData = localStorage.getItem("UsersData");
        let StorebranchmapId = routes.query.storebranchmapid ?? 0;

        let usersData: any;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        function ExportExcel() {
            debugger;
            ExportOption.value = "Excel";
            IsShowExport();
        }

        function ExportPDF() {
            debugger;
            ExportOption.value = "PDF";
            IsShowExport();
        }

        async function IsShowExport() {
            debugger;
            try {
                loading.value = false;

                const pageNum = state.currentPage;
                const pageSize = 0;
                const columnName = columnnametype;
                const columnValue = dataId;
                const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
                const columnValue1 = filterItems.value.SupplierId
                    ? filterItems.value.SupplierId
                    : "";
                const columnName2 = filterItems.value.Code ? "DocNo" : "";
                const columnValue2 = filterItems.value.Code
                    ? filterItems.value.Code
                    : "";
                const columnName3 = filterItems.value.PoCode ? "RefNo" : "";
                const columnValue3 = filterItems.value.PoCode
                    ? filterItems.value.PoCode
                    : "";

                let Condition =
                    "sm.HospitalId=" +
                    usersData.OrganizationId +
                    " and sm.BranchId=" +
                    usersData.BranchId +
                    " and sm.StoreBrMapId=" +
                    StorebranchmapId +
                    "";

                if (filterItems.value.StatusIds != "") {
                    Condition =
                        Condition +
                        " and (sm.Status IN(" +
                        filterItems.value.StatusIds +
                        ")) ";
                } else if (
                    buttonFilter.value.Name != "" &&
                    buttonFilter.value.Name != "All"
                ) {
                    Condition =
                        Condition +
                        " and (sm.Status IN(" +
                        buttonFilter.value.Id +
                        ")) " +
                        "and sm.Status !=(3)";
                } else if (filterItems.value.StatusIds == "") {
                    Condition =
                        "sm.HospitalId=" +
                        usersData.OrganizationId +
                        " and sm.BranchId=" +
                        usersData.BranchId +
                        "and sm.Status!=3";
                }
                let Flag = 1,
                    searchOption = "";

                if (SearchValue.value.inputValue != "") {
                    Flag = 2;
                    searchOption = SearchValue.value.inputValue;
                }

                let response = await commonService.GetStockWOTM(
                    SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
                    SearchValue.value.toDate ? SearchValue.value.toDate : "",
                    pageSize,
                    pageNum,
                    6,
                    columnName,
                    columnValue,
                    columnName1,
                    columnValue1,
                    columnName2,
                    columnValue2,
                    Flag,
                    searchOption,
                    columnName3,
                    columnValue3,
                    Condition
                );


                response["result"] = response["result"].map((item) => {
                    item.Amount = Number(item.Amount).toFixed(2);
                    return item;
                }).filter(
                    (x) =>
                        x.HospitalId == usersData.OrganizationId &&
                        x.BranchId == usersData.BranchId
                );

                rowsCount.value =
                    response["result"].length > 0
                        ? response["result"][0]["rowscount"]
                        : 0;

                ExportList.value = response["result"].map((item) => {
                    const filteredItem = {};

                    headers.forEach(({ header, field }) => {
                        filteredItem[header] = item[field];
                    });

                    return filteredItem;
                });

                console.log(items.value);
                loading.value = false;
            } catch (error) {
                console.log(error);
            }
        }
        return {
            ExportOption,
            ExportList,
            PageName,
            ExportExcel,
            ExportPDF,

            raisePO,
            QtyChk,
            UpdateQty,
            globalFilterFields,
            filters,
            headers,
            items,
            itemcatfilter,
            //  itemcatfilteroptions,
            selectedItem
        };
    },

});
</script>
<style lang="scss">
.raisepo {
    display: flex;
    background-color: #F0F7FE;
    border: 1px solid #E1E1E1;
    align-items: center;
    //width: 45%;
    width: 430px;

    padding: 7px 3px;
    justify-content: space-evenly;

    //margin-bottom: 15px
    p {
        cursor: pointer;
        border-right: 1px solid #E1E1E1;
        padding-right: 20px;
    }

    span {
        cursor: pointer;
    }

}

.raisepoflex {
    display: flex;
    align-items: center;
    /* width: 40%; */
    /* padding: 7px 3px; */
    justify-content: space-between;
}
</style>